<div [formGroup]="addressForm">
  <div class="input-form-box">
    <h1 class="label">{{ 'FORM.LABELS.ADDRESS' | translate }}*</h1>
    <div class="input-box">
      <input
        type="text"
        formControlName="address"
        class="input"
        placeholder="{{ 'FORM.PLACEHOLDER.ADDRESS' | translate }}"
        [ngStyle]="{'border': (hasError(addressControl, 'required') || hasError(addressControl, 'invalidAddress') || hasError(addressControl, 'stripeVerification')) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
        (input)="onAddressInput(addressControl?.value || '')"
        (focus)="openSuggestions('address')"
        (blur)="hideSuggestions('address')"
      />
      <button *ngIf="addressSuggestions.length > 0" type="button" class="toggle-suggestions-btn" (mousedown)="toggleSuggestions('address', $event)">
        <span>{{ showAddressDropdown ? '▲' : '▼' }}</span>
      </button>
      <div class="suggestions-loading" *ngIf="loadingAddressSuggestions">
        Chargement...
      </div>
      <div class="suggestions" *ngIf="addressSuggestions.length && showAddressDropdown">
        <div class="suggestion-item" *ngFor="let item of addressSuggestions; trackBy: trackBySuggestion" (mousedown)="selectAddressSuggestion(item)">
          <div class="suggestion-title">{{ suggestionTitle(item) }}</div>
          <div class="suggestion-meta" *ngIf="suggestionSecondary(item)">{{ suggestionSecondary(item) }}</div>
        </div>
      </div>
    </div>
    <span
      *ngIf="hasError(addressControl, 'required') || hasError(addressControl, 'invalidAddress') || hasError(addressControl, 'stripeVerification')"
      class="error-message"
    >
      <div *ngIf="hasError(addressControl, 'required')">
        {{ 'FORM.ERROR.REQUIRED' | translate }}
      </div>
      <div *ngIf="hasError(addressControl, 'invalidAddress')">
        {{ 'FORM.ERROR.ADDRESS' | translate }}
      </div>
      <div *ngIf="hasError(addressControl, 'stripeVerification')">
        {{ addressControl?.errors?.['stripeVerification'] }}
      </div>
    </span>
  </div>

  <div class="input-form-box" *ngIf="showZipField">
    <h1 class="label">{{ 'FORM.LABELS.ZIP_CODE' | translate }}*</h1>
    <div class="input-box">
      <input
        type="text"
        formControlName="zip_code"
        class="input"
        placeholder="{{ 'FORM.PLACEHOLDER.ZIP_CODE' | translate }}"
        [ngStyle]="{'border': (hasError(zipControl, 'required') || hasError(zipControl, 'invalidZip') || hasError(zipControl, 'stripeVerification') || hasError(zipControl, 'postalCodeCityMismatch')) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
        (blur)="onFieldBlur('zip_code')"
      />
    </div>
    <div
      *ngIf="hasError(zipControl, 'required') || hasError(zipControl, 'invalidZip') || hasError(zipControl, 'stripeVerification') || hasError(zipControl, 'postalCodeCityMismatch')"
      class="error-message"
    >
      <div *ngIf="hasError(zipControl, 'required')">
        {{ 'FORM.ERROR.REQUIRED' | translate }}
      </div>
      <div *ngIf="hasError(zipControl, 'invalidZip')">
        {{ 'FORM.ERROR.ZIP_CODE' | translate }}
      </div>
      <div *ngIf="hasError(zipControl, 'stripeVerification')">
        {{ zipControl?.errors?.['stripeVerification'] }}
      </div>
      <div *ngIf="hasError(zipControl, 'postalCodeCityMismatch')">
        <span *ngIf="zipControl?.errors?.['geographicError']">
          {{ zipControl?.errors?.['geographicError'] }}
        </span>
        <span *ngIf="!zipControl?.errors?.['geographicError']">
          Le code postal ne correspond pas a la ville indiquee
        </span>
      </div>
    </div>
  </div>

  <div class="input-form-box" *ngIf="showCityField">
    <h1 class="label">{{ 'FORM.LABELS.CITY' | translate }}*</h1>
    <div class="input-box">
      <input
        type="text"
        formControlName="city"
        class="input"
        placeholder="{{ 'FORM.PLACEHOLDER.CITY' | translate }}"
        [ngStyle]="{'border': (hasError(cityControl, 'required') || hasError(cityControl, 'invalidCity') || hasError(cityControl, 'stripeVerification')) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
      />
    </div>
    <span
      *ngIf="hasError(cityControl, 'required') || hasError(cityControl, 'invalidCity') || hasError(cityControl, 'stripeVerification')"
      class="error-message"
    >
      <div *ngIf="hasError(cityControl, 'required')">
        {{ 'FORM.ERROR.REQUIRED' | translate }}
      </div>
      <div *ngIf="hasError(cityControl, 'invalidCity')">
        {{ 'FORM.ERROR.CITY' | translate }}
      </div>
      <div *ngIf="hasError(cityControl, 'stripeVerification')">
        {{ cityControl?.errors?.['stripeVerification'] }}
      </div>
    </span>
  </div>
</div>
